import firebaseApp from './utils/firebase/firebase';
// import

export const saveState = (state) => {
    //VDN - We have to create a new object in order to exclude any datas initialized by listener, in order to avoid duplicates.
    // Duplicate will generate errors
    try {
        const newState = {...state};

        //we delete the reducers that we don't want to keep
        delete newState.history;
        delete newState.user;
        delete newState.editions;

        const serializedState = JSON.stringify({
            ...newState,
            article: {
                ...state.article,
                emoReactionInProgress: false,
                reactionsInProgress: false,
                articleRetrievalInProgress: false
            },
            chatroom: {
                ...state.chatroom,
                messages: []
            },
            /*editions: {
                ...state.editions,
                specificEditionRetrievalInProgress: false
            }*/
        });

        localStorage.setItem('state', serializedState);
    }
    catch (err) {
        console.error('[SaveState]Unable to save data, in the localStorage');
    }
}

export const loadState = new Promise((resolve, reject) => {
    try{
        const serializedState = localStorage.getItem('state');
        const expirationDate = new Date(localStorage.getItem('expirationDate'));
        if(serializedState === null || expirationDate < new Date()) {
            resolve(undefined);
        }

        var persistedState = JSON.parse(serializedState);
        if (persistedState.auth.isUserSignedIn) {
            firebaseApp.auth().onAuthStateChanged(user => { 
                if (user) {
                    
                    resolve(persistedState);

                } else { 
                    resolve(undefined); 
                }
            });   
        }
        else {
            resolve(undefined);
        }
    }
    catch (err) {
        resolve(undefined);
    }
});




// WEBPACK FOOTER //
// ./src/localStorage.js